import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

const RainforestTreeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 200 200">
      <g id="Light_Green" data-name="Light Green">
        <path
          fill="currentColor"
          d="M82.28,109.67c1.86,1.68,3.91,3.42,5,3.98,1.5.75,4.98.81,6.67-.44,1.06-.78-1.58-5.02-3.69-8.05-1.99,2.36-4.8,3.99-7.98,4.51Z"
        />
        <path
          fill="currentColor"
          d="M105.78,102.26c-.11,0-.21-.01-.32-.02-.09,1.88-.22,3.96-.43,5.12-.44,2.49-1,7.91,6.85,4.61.02,0,.03-.01.05-.02,0-.01.01-.03.02-.04,4.24-1.81,7.96-5.42,10-7.66-3.37-.57-6.36-2.14-8.65-4.38-2.13,1.5-4.72,2.38-7.52,2.38Z"
        />
        <path
          fill="currentColor"
          d="M92.94,103.19c-.35,0-.7,0-1.04-.02,1.94,2.46,4.23,5.21,4.91,5.44,1.25.44,3.18,1.37,3.99-1.12.4-1.15.7-3.59.9-5.89-.05-.02-.1-.04-.15-.06-2.59,1.05-5.51,1.65-8.6,1.65Z"
        />
        <path
          fill="currentColor"
          d="M100,23.66c-41.19,0-74.58,33.39-74.58,74.58s33.39,74.58,74.58,74.58,74.58-33.39,74.58-74.58S141.19,23.66,100,23.66ZM131.55,103.06c-1.77.79-3.71,1.28-5.75,1.41-2.48,2.98-7.17,8.1-12.3,10.94-7.54,4.24-5.67,9.53-5.61,12.09.19,13.52,5.11,14.83,4.3,17.19-.5,1.37-6.23-1.43-9.41,1.18-1.87,1.56-2.74.69-5.61-.87-1.62-.81-4.36,3.24-4.36-.87,0-1.62,2.68-10.9,2.68-19.69,0-6.85-6.54-6.54-9.91-8.66-2.4-1.51-5.41-4.45-6.93-6.01-2.32-.26-4.45-1.13-6.24-2.44-1.56,1.08-3.46,1.72-5.52,1.72-.51,0-1.01-.05-1.5-.13,0,0,0,0,0,0,0,0-.01,0-.02,0-4.63-.72-8.14-4.69-8.14-9.53,0-2.05.63-3.94,1.71-5.5-3.84-2.43-6.32-6.16-6.32-10.26,0-5.61,4.54-10.4,10.95-12.32.03-.13.07-.27.11-.4.01-.04.02-.09.04-.13.07-.22.14-.45.22-.67,0-.01,0-.02.01-.03,2.26-6.21,9.05-10.85,17.31-11.38,3.94-4.35,10.23-7.16,17.33-7.16.01,0,.02,0,.03,0,0,0,.02,0,.03,0,6.11,0,11.59,2.06,15.51,5.42-.05-.03-.1-.05-.15-.07,2.42,2.03,4.25,4.53,5.27,7.32.51-.05,1.02-.08,1.55-.08,7.45,0,13.49,5.66,13.64,12.7,2.18,1.58,3.94,3.68,5.05,6.11-.03-.03-.06-.07-.09-.1.6,1.3,1.03,2.69,1.24,4.14,1.99,1.7,3.21,3.95,3.21,6.43,0,5.3-5.55,9.55-12.35,9.65Z"
        />
      </g>
    </SvgIcon>
  );
};

export default RainforestTreeIcon;
